import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import InputContainer from '../InputContainer';
import TextAttribute from '../Fields/TextAttribute';
import EmbedSnippetGenerator from '../EmbedSnippetGenerator';

function EmbedFormDataSection({ meta, form: { groupingName, id, introSubText, introText, leadSource, splashCreative, thankYouURL, title }, onFieldValueChange, onFieldUIStateChange }) {
  const [isURLSaved, setIsURLSaved] = useState(true);

  useEffect(() => {
    // We only set to false if someone tries to generate a snippet without a URL
    if (!meta.isDirty && thankYouURL) {
      setIsURLSaved(true);
    }
  }, [meta.isDirty, thankYouURL]);

  const thankYouURLUiState = {
    isValid: isURLSaved,
    errorDisplay: 'You must save a Thank You URL',
    touched: true,
    required: true,
  };

  const snippetGeneratorProps = {
    setIsURLSaved,
    formID: id,
    groupingName,
    onFieldValueChange,
    onFieldUIStateChange,
  };

  return (
    <div className="container">
      <div className="row">
        <h1>Embeddable Form Data</h1>
      </div>
      <div className="row">
        <form className="border p-3 mt-4 mb-5 rounded-top rounded-bottom">
          <InputContainer
            label="Title"
            keyPath={['title']}
          >
            <TextAttribute
              keyPath={['title']}
              onFieldValueChange={onFieldValueChange}
              onFieldUIStateChange={onFieldUIStateChange}
              value={title || ''}
            />
          </InputContainer>
          <InputContainer
            label="Intro Text"
            keyPath={['introText']}
            className="mt-3"
          >
            <TextAttribute
              keyPath={['introText']}
              onFieldValueChange={onFieldValueChange}
              onFieldUIStateChange={onFieldUIStateChange}
              value={introText || ''}
            />
          </InputContainer>
          <InputContainer
            label="Intro Sub Text"
            keyPath={['introSubText']}
            className="mt-3"
          >
            <TextAttribute
              keyPath={['introSubText']}
              onFieldValueChange={onFieldValueChange}
              onFieldUIStateChange={onFieldUIStateChange}
              value={introSubText || ''}
            />
          </InputContainer>
          <InputContainer
            label="Thank You URL"
            keyPath={['thankYouURL']}
            uiState={thankYouURLUiState}
            className="mt-3"
          >
            <TextAttribute
              keyPath={['thankYouURL']}
              onFieldValueChange={onFieldValueChange}
              onFieldUIStateChange={onFieldUIStateChange}
              value={thankYouURL || ''}
            />
          </InputContainer>
          <InputContainer
            label="Lead Source"
            keyPath={['leadSource']}
            className="mt-3"
          >
            <TextAttribute
              keyPath={['leadSource']}
              onFieldValueChange={onFieldValueChange}
              onFieldUIStateChange={onFieldUIStateChange}
              value={leadSource || ''}
            />
          </InputContainer>
          <InputContainer
            label="Splash Creative"
            keyPath={['splashCreative']}
            className="mt-3"
          >
            <TextAttribute
              keyPath={['splashCreative']}
              className="mb-3"
              onFieldValueChange={onFieldValueChange}
              onFieldUIStateChange={onFieldUIStateChange}
              value={splashCreative || ''}
            />
          </InputContainer>
          <p className="text-center">Note: embedded forms can only see <em>published</em> data. If you make a change above, you must save and re-publish your work.</p>
          <EmbedSnippetGenerator {...snippetGeneratorProps} />
        </form>
      </div>
    </div>
  );
}

EmbedFormDataSection.propTypes = {
  meta: PropTypes.shape({
    isDirty: PropTypes.bool,
  }).isRequired,
  form: PropTypes.shape({
    groupingName: PropTypes.string,
    id: PropTypes.string,
    introSubText: PropTypes.string,
    introText: PropTypes.string,
    name: PropTypes.string,
    leadSource: PropTypes.string,
    splashCreative: PropTypes.string,
    thankYouURL: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
  onFieldUIStateChange: PropTypes.func.isRequired,
};

export default EmbedFormDataSection;
